/**
 * Dialogue lines for each country in various situations
 * Each country has personality-specific taunts, brags, and threats
 */

export const DIALOGUE_LINES = {
  USA: {
    success_propaganda: [
      "Freedom always wins! 🦅",
      "That's how we do it in America!",
      "Liberty prevails again!",
      "USA! USA! USA!",
      "Democracy in action!"
    ],
    success_blackmail: [
      "We have ways of making you cooperate...",
      "The CIA sends its regards.",
      "Nice secrets you got there. Had.",
      "Intelligence is power, baby!"
    ],
    success_deploy_troops: [
      "American military superiority!",
      "Shock and awe, baby!",
      "The eagle has landed!",
      "Don't mess with Uncle Sam!",
      "Freedom delivered by force!"
    ],
    success_diplomacy: [
      "The art of the deal!",
      "Democracy spreads peacefully.",
      "Let's be friends... for now.",
      "Mutual benefit, the American way!"
    ],
    failure: [
      "This isn't over!",
      "We'll be back, stronger!",
      "You got lucky this time!",
      "The eagle never forgets!",
      "Regroup and strike back!"
    ],
    attacked: [
      "You just made a BIG mistake!",
      "Attack America? Really?!",
      "You're gonna regret this!",
      "Nobody attacks the USA!",
      "We will remember this!"
    ]
  },
  
  RUS: {
    success_propaganda: [
      "Mother Russia spreads truth!",
      "Your mind is now ours, comrade!",
      "Russian influence grows!",
      "Soviet tactics still work!",
      "We own your thoughts now!"
    ],
    success_blackmail: [
      "The KGB never fails...",
      "We know EVERYTHING about you.",
      "Your secrets are ours now!",
      "Russian intelligence is superior!",
      "Da, we have kompromat!"
    ],
    success_deploy_troops: [
      "Your Big Russian Bear is stronger than you thought!",
      "Russian army crushes all!",
      "Mother Russia's might!",
      "In Soviet Russia, we attack YOU!",
      "The bear has awakened!"
    ],
    success_diplomacy: [
      "Even Russia can be... diplomatic.",
      "Strategic partnership, da?",
      "We negotiate from strength!",
      "Mother Russia extends hand!"
    ],
    failure: [
      "Winter is coming for you!",
      "The bear remembers...",
      "You will pay for this!",
      "Russia does not forget!",
      "Temporary setback only!"
    ],
    attacked: [
      "You dare attack Mother Russia?!",
      "The bear will have revenge!",
      "You have made enemy of Russia!",
      "Consequences will be SEVERE!",
      "Russian fury is legendary!"
    ]
  },
  
  CHN: {
    success_propaganda: [
      "The Dragon's wisdom prevails!",
      "Chinese influence is inevitable!",
      "Ancient strategies, modern victory!",
      "The Middle Kingdom rises!",
      "5000 years of wisdom wins!"
    ],
    success_blackmail: [
      "We play the long game...",
      "Chinese intelligence is patient.",
      "Your secrets are catalogued.",
      "The Dragon sees all!",
      "Debt collected, one way or another!"
    ],
    success_deploy_troops: [
      "The Dragon's claws are sharp!",
      "Chinese military power grows!",
      "Ancient art of war in action!",
      "The Sleeping Dragon awakens!",
      "One China, many soldiers!"
    ],
    success_diplomacy: [
      "Win-win cooperation!",
      "Silk Road of friendship!",
      "Peaceful rise continues!",
      "Strategic partnership established!"
    ],
    failure: [
      "The Dragon bides its time...",
      "Patience is our strength!",
      "Century of humiliation never again!",
      "We will return stronger!",
      "Long-term planning always wins!"
    ],
    attacked: [
      "You provoke the Dragon?!",
      "China will not be humiliated!",
      "You underestimate our resolve!",
      "The Dragon's revenge is patient!",
      "This aggression will not stand!"
    ]
  },
  
  EU: {
    success_propaganda: [
      "European values triumph!",
      "Culture and sophistication win!",
      "Unity in diversity!",
      "The EU way prevails!",
      "Civilized persuasion works!"
    ],
    success_blackmail: [
      "Even diplomats have secrets...",
      "Brussels knows your business!",
      "GDPR doesn't apply to us!",
      "European intelligence cooperates!",
      "Sanctions are coming..."
    ],
    success_deploy_troops: [
      "EU peacekeepers... armed!",
      "Don't underestimate Europe!",
      "NATO article 5, anyone?",
      "The Union shows its teeth!",
      "European military complex!"
    ],
    success_diplomacy: [
      "Diplomacy is what we do best!",
      "Another peaceful resolution!",
      "The European way!",
      "Negotiation over confrontation!",
      "Multilateralism wins!"
    ],
    failure: [
      "We'll resolve this diplomatically!",
      "Brussels will respond appropriately!",
      "A minor setback for the Union!",
      "We stand united in response!",
      "This requires a committee..."
    ],
    attacked: [
      "Attack the EU? Unacceptable!",
      "You violate international law!",
      "Brussels is NOT pleased!",
      "Sanctions incoming!",
      "This will have consequences!"
    ]
  },
  
  NK: {
    success_propaganda: [
      "Dear Leader is always right!",
      "Juche ideology spreads!",
      "The world fears our strength!",
      "North Korea best Korea!",
      "Revolutionary spirit prevails!"
    ],
    success_blackmail: [
      "We have... interesting files on you!",
      "Dear Leader knows your secrets!",
      "Nobody expects NK intelligence!",
      "We punch above our weight!",
      "Underestimate us? Mistake!"
    ],
    success_deploy_troops: [
      "The hermit kingdom STRIKES!",
      "Million-man army in action!",
      "Dear Leader commands victory!",
      "Korean People's might!",
      "We are not so small!"
    ],
    success_diplomacy: [
      "Even NK can negotiate!",
      "Dear Leader shows mercy!",
      "Strategic breakthrough!",
      "The world respects us now!"
    ],
    failure: [
      "Imperialist conspiracy!",
      "Dear Leader will respond!",
      "This is Western sabotage!",
      "We will show our power!",
      "Nuclear option on table!"
    ],
    attacked: [
      "You attack the great NK?!",
      "FIRE AND FURY!",
      "Dear Leader will avenge this!",
      "Sea of fire awaits you!",
      "You have sealed your fate!"
    ]
  }
};

/**
 * Get random dialogue line for country and situation
 * @param {string} countryCode - Country code
 * @param {string} situation - Situation type (success_propaganda, failure, attacked, etc.)
 * @returns {string} Random appropriate dialogue line
 */
export function getDialogueLine(countryCode, situation) {
  const countryDialogue = DIALOGUE_LINES[countryCode];
  if (!countryDialogue) return "";
  
  const lines = countryDialogue[situation];
  if (!lines || lines.length === 0) return "";
  
  return lines[Math.floor(Math.random() * lines.length)];
}
